import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {RouteObject} from '@github-ui/react-router'
import type {ComponentType} from 'react'

import {buildCommitPathRoute} from './commit-path-route'
import {buildCommitRoute} from './commit-route'
import {buildCommitsLayoutRoute} from './commits-layout-route'
import {buildCommitsRefRoute} from './commits-ref-route'
import {buildCommitsRoute} from './commits-route'

export interface CommitsRouteComponents {
  CommitsLayout: ComponentType
  CommitsEntrypoint: ComponentType
  CommitsRefEntrypoint: ComponentType
  CommitEntrypoint: ComponentType
  CommitPathEntrypoint: ComponentType
}

/** Builds the repo-scoped commits routes for either the standalone or repo app builder. */
export function createCommitsRoutes(
  appBuilder: DataRouterApplicationBuilder<string>,
  components: CommitsRouteComponents,
): RouteObject[] {
  const {CommitsLayout, CommitsEntrypoint, CommitsRefEntrypoint, CommitEntrypoint, CommitPathEntrypoint} = components

  return [
    buildCommitsLayoutRoute(appBuilder).toRoute({
      Component: CommitsLayout,
      children: [
        buildCommitsRoute(appBuilder).toRoute({Component: CommitsEntrypoint}),
        buildCommitsRefRoute(appBuilder).toRoute({Component: CommitsRefEntrypoint}),
        buildCommitRoute(appBuilder).toRoute({Component: CommitEntrypoint}),
        buildCommitPathRoute(appBuilder).toRoute({Component: CommitPathEntrypoint}),
      ],
    }),
  ]
}
